// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__B3vfS","tabs":"Gallery_tabs__rPRVL","tab":"Gallery_tab__uQMXz","active":"Gallery_active__szscH"};